const RateStart = ({ value, postRate, my_rating }) => {
    const class_star = my_rating >= value ? 'fas fa-star' : 'far fa-star';
    return (
        <>
            <a onClick={(e) => { postRate(value); }}><i className={class_star}></i></a>
        </>
    );
}

export default RateStart;